import axios from 'axios';
import Swal from 'sweetalert2';
import QueryString from 'qs';

/**
 * Init
 */
const documentReady = function () {
    new VoucherFormHandler();
};

if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
    documentReady();
} else {
    document.addEventListener('DOMContentLoaded', documentReady);
}

/**
 * [...]
 */
class VoucherFormHandler {
    constructor() {
        this.form = document.getElementById('js-voucher-form');

        if (!this.form) {
            throw new Error(`Form with given selector not found.`);
        }

        this.roomSelect = this.form.querySelector('select[name="room"]');
        this.timeSelect = this.form.querySelector('select[name="time"]');
        this.personQtySelect = this.form.querySelector('select[name="persons_quantity"]');
        this.priceInput = this.form.querySelector('input[name="price"]');
        this.pricePlace = this.form.querySelector('span[id="js-price-place"]');

        if (!this.roomSelect || !this.timeSelect || !this.personQtySelect || !this.priceInput || !this.pricePlace) {
            throw new Error("One or more form fields are missing.");
        }

        const dataPersonsCount = this.roomSelect.getAttribute('data-persons-count');

        if (!dataPersonsCount) {
            console.error("Missing 'data-persons-count' attribute on voucher field.");
            return;
        }

        this.personsCountData = JSON.parse(atob(dataPersonsCount));
        this.currency = this.priceInput.getAttribute('data-currency');

        this.attachEventListeners();

        // Initial price count
        this.handleRoomChange();
        this.handleFieldChange();
    }

    /**
     * Event listeners.
     */
    attachEventListeners() {

        // Room change
        this.roomSelect.addEventListener('change', () => this.handleRoomChange());

        // Any change that could impact price
        [this.roomSelect, this.timeSelect, this.personQtySelect, this.priceInput].forEach(field => {
            field.addEventListener('change', () => this.handleFieldChange());
        });

        // Form send
        this.form.addEventListener('submit', (event) => this.sendForm(event));
    }

    /**
     * [...]
     *
     * @returns 
     */
    handleRoomChange() {
        try {
            const selectedRoomValue = this.roomSelect.value;

            if (this.personsCountData[selectedRoomValue]) {
                this.updatePersonQtyOptions(Object.keys(this.personsCountData[selectedRoomValue]));
            } else {
                console.warn("Selected room value not found in data.");
                this.updatePersonQtyOptions([]);
            }

            this.personQtySelect.disabled = false;
        } catch (error) {
            console.error("Failed to parse 'data-persons-count':", error);
        }
    }

    /**
     * Update persons qount input field.
     * 
     * @param {*} options 
     */
    updatePersonQtyOptions(options) {

        // Clear existing options
        this.personQtySelect.innerHTML = "";

        options.forEach(value => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = value;
            this.personQtySelect.appendChild(option);
        });

        // // Check if old option is still available, if yes, then restore it. // FIXME:
        // if (currentQty) {
        //     for (i = 0; i < this.personQtySelect.length; ++i) {
        //         if (this.personQtySelect.options[i].value == currentQty){
        //             this.personQtySelect.value = currentQty
        //         }
        //     }
        // }
    }

    /**
     * [...]
     */
    async handleFieldChange() {
        const selectedRoomValue = this.roomSelect.value;
        const timeValue = this.timeSelect.value;
        const personQtyValue = this.personQtySelect.value;

        // Clear value
        if (this.personsCountData[selectedRoomValue][personQtyValue][timeValue]) {
            this.priceInput.value = `${this.personsCountData[selectedRoomValue][personQtyValue][timeValue]} ${this.currency}`;
            this.pricePlace.innerHTML = `${this.personsCountData[selectedRoomValue][personQtyValue][timeValue]} ${this.currency}`;
        } else {
            this.priceInput.value = '-';
            this.pricePlace.innerHTML = '-';
        };
    }

    /**
     * [...]
     *
     * @param {*} event 
     */
    sendForm(event) {
        event.preventDefault();

        const formData = new FormData(this.form);
        const dataObject = {};
        formData.forEach((value, key) => {
            dataObject[key] = value;
        });

        const honeypot = document.getElementById('js-hnypot');
        const contactSendButton = document.getElementById('js-voucher-send-button');

        if (honeypot.value.length === 0) {
            contactSendButton.setAttribute('disabled', 'true');
            contactSendButton.textContent = 'Wysyłam';

            axios.post(ajax.url,
                QueryString.stringify({
                    action: 'send_voucher_form',
                    security: ajax.nonce,
                    data: dataObject
                })).then((responseRaw) => {
                    const response = responseRaw.data;

                    if (responseRaw.data.success === true) {
                        contactSendButton.textContent = 'Wysłano';
                        contactSendButton.classList.add('is-sent');

                        Swal.fire({
                            icon: 'success',
                            title: 'Udało się!',
                            text: 'Wiadomość została wysłana.'
                        });
                    } else {
                        contactSendButton.textContent = 'Wyślij';
                        contactSendButton.removeAttribute('disabled');

                        let errorsList = '';

                        response.data.errors.forEach((element) => {
                            errorsList += `<li>${element}</li>`;
                        });

                        Swal.fire({
                            icon: 'warning',
                            title: 'Uwaga',
                            html: `W formularzu wystąpiły następujące błędy:<ul style="text-align: left">${errorsList}</ul>`
                        });
                    }
                }).catch(() => {
                    contactSendButton.textContent = 'Błąd';
                    contactSendButton.classList.add('is-error');

                    Swal.fire({
                        icon: 'error',
                        title: 'Błąd',
                        text: 'Podczas wysyłki wiadomości wystąpił nieoczekiwany błąd.'
                    });
                });
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Błąd',
                text: 'Prawdopodobna próba wysłania spam-wiadomości!'
            });
        }
    }
}
